import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { BannerWrapper } from '#src/app/shared/components/banners/layout';
import { SimpleHtml } from '#src/app/shared/components/html';

type Props = {
	message: string;
};

export const MaintenanceBanner: React.FC<Props> = ({ message }) => {
	return (
		<BannerWrapper className="py-1">
			<Text as="div" size="small">
				<SimpleHtml html={message} />
			</Text>
		</BannerWrapper>
	);
};
